var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            id: "app",
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            title: _vm.title,
            "inline-message": "",
            width: _vm.isZh ? "1000px" : "1200px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "guaranteeForm",
              attrs: {
                model: _vm.guaranteeForm,
                disabled: _vm.locked,
                "label-width": _vm.isZh ? "80px" : "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 12, sm: 12, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_GuaranteeType")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "GuaranteeType",
                                filterable: "",
                                placeholder: _vm.$t("common.defaultPlaceholder")
                              },
                              on: {
                                change: function(p) {
                                  _vm.guaranteeForm.guaranteeType = p
                                }
                              },
                              model: {
                                value: _vm.guaranteeForm.guaranteeType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.guaranteeForm,
                                    "guaranteeType",
                                    $$v
                                  )
                                },
                                expression: "guaranteeForm.guaranteeType"
                              }
                            },
                            _vm._l(_vm.guaranteeTypeArrays, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, sm: 12, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_GuaranteeName")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "GuaranteeName" },
                            model: {
                              value: _vm.guaranteeForm.guaranteeName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.guaranteeForm,
                                  "guaranteeName",
                                  $$v
                                )
                              },
                              expression: "guaranteeForm.guaranteeName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 12, sm: 12, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_EffectiveDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "EffectiveDate",
                              type: "date",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_Select") +
                                _vm.$t("CargoMsg.Cargo_EffectiveDate")
                            },
                            model: {
                              value: _vm.guaranteeForm.effectiveDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.guaranteeForm,
                                  "effectiveDate",
                                  $$v
                                )
                              },
                              expression: "guaranteeForm.effectiveDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 12, sm: 12, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_InvalidDate") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "ExpiryDate",
                              type: "date",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_Select") +
                                _vm.$t("CargoMsg.Cargo_InvalidDate")
                            },
                            model: {
                              value: _vm.guaranteeForm.expiryDate,
                              callback: function($$v) {
                                _vm.$set(_vm.guaranteeForm, "expiryDate", $$v)
                              },
                              expression: "guaranteeForm.expiryDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.innerVisible
                ? _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_AuthorizedClient"),
                            name: "customerGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "customer-group",
                            attrs: {
                              "detail-value": _vm.customerDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "customer",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormCustomer }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_BusinessType"),
                            name: "businessTypeGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "businessType-group",
                            attrs: {
                              "detail-value": _vm.businessTypeDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "businessType",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormBusinessTyp }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_TypeOfGoods"),
                            name: "cargoTypeGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "cargoType-group",
                            attrs: {
                              "detail-value": _vm.cargoTypeDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "cargoType",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormCargoType }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_FLCLType"),
                            name: "containerType"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "containerType-group",
                            attrs: {
                              "detail-value": _vm.containerTypeDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "containerType",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormContainerType }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_PortOfLoadingSea"),
                            name: "seaPolGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "sea-pol-group",
                            attrs: {
                              "detail-value": _vm.seaPolDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "seaPol",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormSeaPolGroup }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_DestinationPortSea"),
                            name: "seaPodGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "sea-pod-group",
                            attrs: {
                              "detail-value": _vm.seaPodDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "seaPod",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormSeaPodGroup }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_Shipper"),
                            name: "shipperGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "shipper-group",
                            attrs: {
                              "detail-value": _vm.shipperDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "shipper",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormShipper }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_Consignee"),
                            name: "consigneeGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "consignee-group",
                            attrs: {
                              "detail-value": _vm.consigneeDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "consignee",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormConsignee }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_Carrier"),
                            name: "carrierGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "carrier-group",
                            attrs: {
                              "detail-value": _vm.carrierDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "carrier",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormCarrier }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_BookingAgent"),
                            name: "bookingAgentGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "booking-agent-group",
                            attrs: {
                              "detail-value": _vm.bookingAgentDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "bookingAgent",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormBookingAgent }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_ShippingRouteArea"),
                            name: "routeAreGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "route-are-group",
                            attrs: {
                              "detail-value": _vm.routeAreaDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "routeArea",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormRouteArea }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_DestinationAgent"),
                            name: "destinationAgentGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "destination-agent-group",
                            attrs: {
                              "detail-value": _vm.destinationAgentDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "destinationAgent",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormDestinationAgent }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_NominatedAgent"),
                            name: "nominatedAgentGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "nominated-agent-group",
                            attrs: {
                              "detail-value": _vm.nominatedAgentDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "nominatedAgent",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormNominatedAgent }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_AvailableBranch"),
                            name: "availableBranchGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "available-branch-group",
                            attrs: {
                              "detail-value": _vm.availableBranchDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "availableBranch",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormAvialableBranch }
                          })
                        ],
                        1
                      ),
                      _vm.guaranteeForm.uuid || _vm.locked
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                label: _vm.$t("CargoMsg.Cargo_FileHistory"),
                                name: "fileHistoryGroup"
                              }
                            },
                            [
                              _c("guarantee-file-history-tab", {
                                ref: "file-history",
                                attrs: {
                                  lazy: true,
                                  context: this,
                                  uuid: _vm.guaranteeForm.uuid
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              { staticStyle: { "padding-right": "5px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "confirm",
                      disabled: _vm.locked,
                      type: "primary"
                    },
                    on: { click: _vm.submitForm }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "cancel" },
                    on: {
                      click: function($event) {
                        _vm.innerVisible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }